import AxiosService from "@/Services/AxiosService";
import { Inject, Service } from "vue-di-container";

@Service()
export default class RequestsSendersService {
    @Inject(AxiosService) public axiosService!: AxiosService;

    public async GetSendersByNodes(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-by-nodes";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersByNodes(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-senders-by-nodes";
            const result = await this.axiosService.axiosInstance.post(url, null);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersDuration(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-duration";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetRequestsBySmsProviderAndSenderType(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/requests-by-sms-provider-and-sender-type";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSenderNameLengthCompliance(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/sender-name-length-compliance";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetActiveSendersTimeline(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/active-senders-timeline";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportActiveSendersTimeline(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/active-senders-timeline/export";

            const result = await this.axiosService.axiosInstance.post(url, null);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersExpirationTimeline(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-expiration-timeline";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersDuration(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-duration/export";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportRequestsBySmsProviderAndSenderType(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/requests-by-sms-provider-and-sender-type/export";
            const result = await this.axiosService.axiosInstance.post(url, null);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSenderNameLengthCompliance(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/sender-name-length-compliance/export";

            const result = await this.axiosService.axiosInstance.post(url, null);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersExpirationTimeline(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-expiration-timeline/export";

            const result = await this.axiosService.axiosInstance.post(url, {});
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersRenewalTimeline(filter: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-renewal-timeline";

            const payload = {
                dateFrom: filter ? filter.dateFrom : null,
                dateTo: filter ? filter.dateTo : null,
                tenantId: filter ? filter.tenant : null,
                providerId: filter ? filter.providerId : null,
                customerType: filter ? filter.customerType : null,
                requestType: 0,
            };

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersRenewalTimeline(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/senders-renewal-timeline/export";

            const result = await this.axiosService.axiosInstance.post(url, {});
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetRequestsBySmsProviderAndSenderTypeDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-requests-by-sms-provider-and-sender-type-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetRequestsBySmsProviderAndSenderTypeDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-requests-by-sms-provider-and-sender-type-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportRequestsBySmsProviderAndSenderTypeDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-requests-by-sms-provider-and-sender-type-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetActiveSendersTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-active-senders-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetActiveSendersTimelineDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-active-senders-timeline-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetActiveSendersTimelineDetailsMaxSenderExpiryDate(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-active-senders-timeline-details-max-sender-expiry-date";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportActiveSendersTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-active-senders-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersExpirationTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-expiration-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersExpirationTimelineDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-expiration-timeline-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersExpirationTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-senders-expiration-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersRenewalTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-renewal-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersRenewalTimelineDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-renewal-timeline-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersRenewalTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-senders-renewal-timeline-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersDurationDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-duration-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersDurationDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-duration-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersDurationDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-senders-duration-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersByNodesDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-by-nodes-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSendersByNodesDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-senders-by-nodes-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSendersByNodesDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-senders-by-nodes-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSenderNameLengthComplianceDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-sender-name-length-compliance-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async GetSenderNameLengthComplianceDetailsClients(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/get-sender-name-length-compliance-details-clients";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }

    public async ExportSenderNameLengthComplianceDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/requests/senders/export-sender-name-length-compliance-details";

            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (e) {
            return false;
        }
    }
}